import axios from 'axios';
import ConfigProvider from '../config/Environments';
import { ServiceUrls } from '../Model';
import { HttpRequestHeader } from './HttpRequestHeader';
import { APPLICATION_NAME } from '../constant';
interface Header {
  [key: string]: string | boolean | undefined;
}
// Create an instance of axios
// const axiosInstance = axios.create({
//   baseURL: process.env.REACT_APP_API_BASE_URL, // Set your API base URL here
//   timeout: 10000, // Set a timeout for requests
// });

// Request interceptor
axios.interceptors.request.use(
  (config) => {
    const customConfig = config;

    const token = '';
    // const state = store.getState();
    // const token = state.auth.token; // Adjust according to your state structure
    // if (!customConfig.headers) {
    //     customConfig.headers = {};
    // }
    if (token) {
      customConfig.headers.Authorization = `Bearer ${token}`;
    }
    const Config = ConfigProvider();
    const route =
      Config.httpService.serviceUrls[
        customConfig.subRoute as keyof ServiceUrls
      ];

    const url = `${route}${customConfig.endPoint}`;
    customConfig.url = url;
    const headers: Header = {};
    headers[HttpRequestHeader.ApplicatioName] = APPLICATION_NAME;
    Object.keys(headers).forEach((key) => {
      customConfig.headers?.set(key, headers[key] as string);
    });
    return customConfig;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // if (error.response && error.response.status === 401) {
    //   // Handle unauthorized errors (e.g., token expired)
    //   store.dispatch(logout()); // Adjust according to your logout action
    // }

    return Promise.reject(error);
  },
);

// export default axiosInstance;
